import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateLecture as updateLectureApi } from "../../../../services/dashboard/apiLectures";

function useUpdateLecture() {
    const queryClient = useQueryClient();

    const {
        mutate: updateLecture,
        isLoading: isUpdating,
        error,
    } = useMutation({
        mutationFn: updateLectureApi,

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["lecturesDashboard"],
            });

            toast.success("تم تعديل المحاضره بنجاح");
        },

        onError: (error) => {
            toast.error(error.response.data.message);
        },
    });

    return { updateLecture, isUpdating, error };
}

export default useUpdateLecture;
